import React from 'react';
import { formatDate } from '../../utils/formatHelpers';

/**
 * PalletsCards - Card view for displaying pallets
 */
const PalletsCards = ({
  pallets,
  onView,
  onEdit
}) => {
  if (pallets.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📦</div>
        <p className="empty-text">No pallets found</p>
        <p className="empty-subtext">Create your first pallet to get started</p>
      </div>
    );
  }

  return (
    <div className="pallets-cards-container">
      {pallets.map((pallet) => (
        <div key={pallet.id} className="pallet-card">
          <div className="card-header">
            <div className="card-header-left">
              <span className="card-pallet-number clickable-link" onClick={() => onView(pallet)}>
                {pallet.pallet_number}
              </span>
              {pallet.image_path && (
                <svg className="has-image-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                  <circle cx="12" cy="13" r="4"/>
                </svg>
              )}
            </div>
            <div className="card-header-right">
              {pallet.notes && (
                <span className="pallet-notes-indicator" title={pallet.notes}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2l5 5h-5V4zM6 20V4h5v7h7v9H6z"/>
                    <path d="M8 12h8v2H8zm0 4h5v2H8z"/>
                  </svg>
                </span>
              )}
              {pallet.label_text && (
                <span className="pallet-label-badge" style={{ backgroundColor: pallet.label_color || '#757575' }}>
                  {pallet.label_text}
                </span>
              )}
              {pallet.is_full === 1 && (
                <span className="pallet-full-badge">FULL</span>
              )}
              <span className={`status-badge ${pallet.status.replace(/\s+/g, '-')}`}>
                {pallet.status}
              </span>
            </div>
          </div>
          <div className="card-body">
            {pallet.customer_name && (
              <div className="card-customer">
                <span className="customer-label">Customer:</span>
                <span className="customer-value">{pallet.customer_name}</span>
              </div>
            )}
            <div className="card-lot-info">
              <span className="lot-label">Lot:</span>
              <span className="lot-value">{pallet.all_lot_numbers || pallet.lot_number}</span>
            </div>
            {pallet.item_names && (
              <div className="card-items-preview">
                <span className="items-preview">{pallet.item_names}</span>
              </div>
            )}
            <div className="card-details">
              <div className="card-detail-item">
                <span className="detail-label">Items:</span>
                <span className="detail-value">{pallet.item_count} items</span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Weight:</span>
                <span className="detail-value">{parseFloat(pallet.total_weight || 0).toFixed(2)} kg</span>
              </div>
              <div className="card-detail-item">
                <span className="detail-label">Created:</span>
                <span className="detail-value">{formatDate(pallet.created_at)}</span>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <div style={{display: 'flex', gap: '8px'}}>
              <button
                className="card-action-btn view"
                onClick={() => onView(pallet)}
                style={{flex: 1}}
              >
                View
              </button>
              {pallet.status !== 'shipped' && (
                <button
                  className="card-action-btn edit"
                  onClick={() => onEdit(pallet)}
                  style={{flex: 1}}
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PalletsCards;
